/**
 *
 * @param {string} token JWT token
 * @return {Object} decoded payload from token
 */
export function tokenContent(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]), payloadReviver, 2);
    return payload;
  } catch (error) {
    console.error(error);
    return {};
  }
}

function payloadReviver(key, value) {
  if (['exp', 'iat'].includes(key)) {
    return `${new Date(value * 1e3).toLocaleString()} (${value})`;
  }
  return value;
}
